// extracted by mini-css-extract-plugin
module.exports = {"statusDetail":"index_statusDetail_YK6xC","planViewWrap":"index_planViewWrap_2Ac6q"};